/**
 * The phone tab bar's tabs: the four places a visitor goes most, and a Menu tab
 * that opens the full drawer for everything else. Pure, so
 * tests/tab-bar.test.mjs can check what each kind of visitor is offered.
 *
 * Members get Home, Feed, Circles and Inbox: the social places. Learn (the
 * Fungarium, courses) and the Realm are in the drawer, which the Menu tab opens.
 */
import { APPROVED_MEMBER_ROLES } from '../../auth/member-roles.js';

const MENU = { id: 'menu', label: 'Menu', icon: '☰', menu: true };

/**
 * @param {{user?: object|null, canEnterRealm?: boolean}} opts
 * @returns {Array<{id, label, icon, href?, match?: string[], badge?: boolean, menu?: boolean}>}
 */
export function tabsFor({ user = null, canEnterRealm = false } = {}) {
  const role = user?.publicMetadata?.role || null;
  if (user && APPROVED_MEMBER_ROLES.includes(role)) {
    return [
      { id: 'home', label: 'Home', icon: '✨', href: '/member/dashboard', match: ['/member/dashboard', '/member/threshold'] },
      { id: 'feed', label: 'Feed', icon: '🔥', href: '/member/feed' },
      { id: 'circles', label: 'Circles', icon: '🫂', href: '/member/circles' },
      { id: 'inbox', label: 'Inbox', icon: '✉️', href: '/member/inbox', badge: true },
      MENU,
    ];
  }
  // Visitors, and anyone signed in whose membership is not approved yet.
  return [
    { id: 'home', label: 'Home', icon: '🏛️', href: '/', match: ['/', '/pages/index.html'] },
    { id: 'events', label: 'Events', icon: '📅', href: '/events' },
    { id: 'join', label: 'Join', icon: '🤝', href: '/become-a-member' },
    user
      ? { id: 'dashboard', label: 'Account', icon: '👤', href: '/member/dashboard' }
      : { id: 'signin', label: 'Sign in', icon: '🔑', href: '/member/login' },
    MENU,
  ];
}

/** Which tab is the page the visitor is on, or null. Home matches only itself. */
export function activeTabId(tabs, pathname) {
  const path = (pathname || '/').replace(/\/+$/, '') || '/';
  for (const t of tabs) {
    if (t.menu) continue;
    const roots = t.match || [t.href];
    if (roots.some((r) => (r === '/' ? path === '/' || path === '/pages/index.html' : path === r || path.startsWith(`${r}/`)))) return t.id;
  }
  return null;
}
